<template>
    <div>
        <b-modal
            id="confirm_address_modal"
            modal-class=""
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc>
            <div class="modal-base">
                <div class="modal-base-head">
                    <div class="modal-base-close" @click="closeConfirmModal()"></div>
                    <div id="headline" v-if="type == 'edit'">ยืนยันการแก้ไขที่อยู่</div>
                    <div id="headline" v-else-if="type == 'delete'">ยืนยันการลบที่อยู่</div>
                    <div id="headline" v-else-if="type == 'success'">รับสิทธิ์เรียบร้อยแล้ว</div>
                </div>
                <div class="modal-base-body">
                    <div id="message" v-if="type == 'edit'">
                        <div>กรุณายืนยันการแก้ไขที่อยู่</div>
                        <div>หากที่อยู่ของคุณไม่ถูกต้องโปรดกลับไปแก้ไข</div>
                        <div class="address">
                            <div class="title">Deivery Address</div>
                            <div class="content">
                                <div class="address-name">{{ address.addressName }}</div>
                                <div>{{ address.firstname }} {{ address.lastname }}</div>
                                <div>{{ address.contactNumber }}</div>
                                <div> {{ address.address }} {{ address.subDistrictName }} {{ address.districtName }} {{ address.provinceName }} {{ address.zipcode }}</div>
                            </div>
                        </div>
                    </div>
                    <div id="message" v-else-if="type == 'delete'">คุณต้องการลบที่อยู่นี้ใช่หรือไม่</div>
                    <div id="message" v-else-if="type == 'success'" v-html="campaign.defaultPrivilegeMessage">
                        
                    </div>
                </div>
                <div class="modal-base-footer">
                    <div v-if="type == 'success'" class="btn-confirm-success">
                        <div class="col-btn wrapper-btn-cancel">
                            <div class="btn btn-secondary btn-cancel" @click="clickCloseSuccess()">ดูประวัติการใช้คะแนน</div>
                        </div>
                    </div>
                    <div v-else class="btn-confirm-non-success">
                        <div class="col-btn wrapper-btn-cancel">
                            <div class="btn btn-secondary btn-cancel" @click="clickClose()">{{ closeBtn }}</div>
                        </div>
                        <div class="col-btn wrapper-btn-confirm">
                            <div class="btn btn-primary btn-confirm" @click="clickConfirm()">{{ confirmBtn }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
// import Vue from "vue";
// import Util from "@/helper/Utility.js";
// import Moment from "moment";
// import Locale from "@/helper/locale/locale.js";

export default {
    name: 'ConfirmAddressModal',
    props: {
        lbl: Object,
        address: Object,
        type: String,
        campaign: Object,
        busAddressSuccessModal: Object
    },
    data: function () {
        return {
            closeBtn: 'ยกเลิก',
            confirmBtn: 'ยืนยัน',
        };
    },
    mounted: function () {
        this.busAddressSuccessModal.$on('showConfirmAddressModal', this.initialConfirmModal);
        this.busAddressSuccessModal.$on('hideConfirmAddressModal', this.closeConfirmModal);
    },
    methods: {
        initialConfirmModal: function () {
            if (this.type == 'edit') {
                this.closeBtn = 'กลับไปแก้ไข'
            }
            this.$bvModal.show('confirm_address_modal');
        },
        closeConfirmModal: function () {
            this.$bvModal.hide('confirm_address_modal');
        },
        clickClose: function () {
            this.closeConfirmModal();
            if (this.type == 'edit') {
                this.$emit('onReEditAddress');
            } else if (this.type == 'success') {
                this.$emit('onSuccessToHistory');
            }
        },
        clickConfirm: function () {
            this.closeConfirmModal();
            if (this.type == 'delete') {
                this.$emit('onConfirmDeleteAddress');
            } else if (this.type == 'edit') {
                this.$emit('onConfirmToRedeem');
            }
        },
        clickCloseSuccess: function() {
            this.closeConfirmModal();
            this.$router.push({ name: 'history'});
        }
    }
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/component/modal/modal.scss";
    @import "@/style/base/common.scss";
    #confirm_address_modal {
        @extend %modal-base;
    }
    #headline {
        text-align: center;
        font-size: 24px;
        font-weight: bold;
        color: #0e78c1;
    }

    #message {
        font-size: 20px;
        font-weight: 500;
        line-height: 1;
        text-align: center;
        padding: 30px 0;
        color: #4b4b4b;
    }

    .modal-base-body {
        .address {
            text-align: left;
            border: 1px solid #c3e2f6;
            border-radius: 10px;
            background-color: #e8f5fc;
            color: #333333;
            font-size: 20px;
            font-weight: 500;
            padding: 8px;
            margin-top: 30px;
        }
        .title {
            padding-bottom: 8px;
        }
        .content {
            border-top: 1px solid #c3e2f6;
            padding-top: 8px;
            .address-name {
                font-weight: 500;
            }
        }
    }

    .modal-base-footer {
        .btn-confirm-success {
            .col-btn {
                display: flex;
                width: 100%;
                &.wrapper-btn-cancel {
                    padding-right: 7.5px;
                    .btn-cancel {
                        width: 100%;
                        font-size: 23px;
                        background-color: white;
                        color: #0e78c1;
                        border: 1;
                        border-color: #0e78c1;
                        border-radius: 5px;
                    }
                }
            }
        }
        .btn-confirm-non-success {
            display: flex;
            width: 100%;

            .col-btn {
                width: 50%;
                display: flex;
                &.wrapper-btn-cancel {
                    padding-right: 7.5px;
                    .btn-cancel {
                        width: 100%;
                        font-size: 23px;
                        background-color: white;
                        color: #0e78c1;
                        border: 1;
                        border-color: #0e78c1;
                        border-radius: 5px;
                    }
                }
                &.wrapper-btn-confirm {
                    padding-left: 7.5px;
                    .btn-confirm {
                        width: 100%;
                        color: white;
                        border: 1;
                        font-size: 23px;
                        background-image: url('../../assets/campaign/button_redeem@2x.png');
                        background-repeat: no-repeat;
                        background-size: 100% 100%;
                        background-position: center center;
                    }
                }
            }
        }
    }



</style>
<style lang="scss">
    #confirm_address_modal {
        .modal-dialog {
            padding: 0 15px;
            .modal-content {
                border-radius: 15px;
            }
        }
    }
</style>
